export default __webpack_public_path__ + "static/media/L0007.932b1f06.png";